import React from "react";
import SupportPageDetails from "./SupportPageDetails";
import CustomerPortal from '../logo/CustomerPortal.png';
const SupportPage = () => (
  <div className="my-nodes-page">    
    <div className="main-content">
      <a href="https://customerportal.cygate.se"><img src={CustomerPortal} width="100%" height="30%"/></a>
      <SupportPageDetails />
    </div>
  </div>
);
export default SupportPage;



// WEBPACK FOOTER //
// ./src/support/SupportPage.js